<div class="sortable">
  <div *ngIf="!useDropdown" class="ui celled horizontal list">
    <div class="item" style="border: none">Sort by:</div>
    <div *ngFor="let key of keys" (click)="sort(key.id)" [style.opacity]="key.id == sortBy ? '1' : '0.87'" class="item key">
      <span>{{key.name}}</span>
      <i class="sort icons">
        <i [class.disabled]="reverse || key.id != sortBy" class="icon sort ascending"></i>
        <i [class.disabled]="!reverse || key.id != sortBy" class="icon sort descending"></i>
      </i>
    </div>
  </div>
  <div *ngIf="useDropdown">
    Sort by:
    <dropdown [options]="keys" [ngModel]="sortBy" (modelChange)="sort(sortBy)" valueType="id"></dropdown>
    <button (click)="sort(sortBy)" class="ui icon basic button">
      <i class="sort icons">
        <i [class.disabled]="reverse" class="icon sort ascending"></i>
        <i [class.disabled]="!reverse" class="icon sort descending"></i>
      </i>
    </button>
  </div>
</div>
